import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { ROUTES } from '../routePaths';
import PublicHeader from './PublicHeader';
import PublicFooter from './PublicFooter';

export default function PublicLayout() {
  const isAuthenticated = useSelector(state => Boolean(
    state.sessionDetail?.transScriptSession ||
    localStorage.getItem('transcriptSession') ||
    localStorage.getItem('vendxSessionID')
  ));
  const location = useLocation();

  if (isAuthenticated) {
    return <Navigate to={`${ROUTES.HOME}${location.search}`} replace />;
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        bgcolor: 'var(--grey-0)',
        overflow: 'auto',
      }}
    >
      <PublicHeader />
      <Box component="main" sx={{ flex: 1, width: '100%' }}>
        <Outlet />
      </Box>
      <PublicFooter />
    </Box>
  );
}
